import { createRouter, createWebHistory } from "vue-router";
import Index from "@/views/Index.vue";
import Terms from "@/views/static/Terms.vue"
import Privacy from "@/views/static/Privacy.vue"
import Rules from "@/views/static/Rules.vue"
import FAQ from "@/views/static/FAQ.vue"
import Partnerships from "@/views/static/Partnerships.vue"
import Register from "@/views/Register.vue";
import AccountCreated from "@/views/account/AccountCreated.vue";
import Login from "@/views/Login.vue";
import Play from "@/views/Play.vue"
import StoreSuccess from "@/views/static/StoreSuccess.vue"
import Account from "@/views/account/Account.vue"
import PurchaseHistory from "@/views/account/PurchaseHistory.vue"
import ChangePassword from "@/views/account/ChangePassword.vue"
import RequestPasswordReset from "@/views/account/RequestPasswordReset.vue"
import ResetPassword from "@/views/account/ResetPassword.vue"
import NotFound from "@/views/NotFound.vue"
import store from "@/store/index.js";

const routes = [
  { path: "/", name: "Index", component: Index },
  { path: "/terms", name: "Terms", component: Terms },
  { path: "/privacy", name: "Privacy", component: Privacy },
  { path: "/rules", name: "Rules", component: Rules },
  { path: "/faq", name: "FAQ", component: FAQ },
  { path: "/partnerships", name: "Partnerships", component: Partnerships },
  { path: "/register", name: "Register", component: Register },
  { path: "/welcome", name: "Welcome", component: AccountCreated },
  { path: "/login", name: "Login", component: Login },
  { path: "/play", name: "Play", component: Play },
  { path: "/success", name: "StoreSuccess", component: StoreSuccess },
  { path: "/account", name: "Account", component: Account, meta: { auth: true }},
  { path: "/account/purchases", name: "PurchaseHistory", component: PurchaseHistory, meta: { auth: true } },
  { path: "/account/change-password", name: "ChangePassword", component: ChangePassword, meta: { auth: true } },
  { path: "/account/request-password-reset", name: "RequestPasswordReset", component: RequestPasswordReset },
  { path: "/account/reset-password", name: "ResetPassword", component: ResetPassword },
  { path: "/:catchAll(.*)", name: "404", component: NotFound },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }
  },
});

router.beforeEach((to, from, next) => {
  const loggedIn = store.getters.isLoggedIn
  if (loggedIn) {
    store.dispatch('getAuthenticatedUser') // Logged in on an auth page, fetch user data from API.
  }

  if (loggedIn && (to.fullPath === "/login" || to.fullPath === "/register")) {
    next("/");
  } else if (to.meta.auth && !loggedIn) {
    next("/login");
  } else {
    next();
  }
})

export default router;
